function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

var _InteractionManager_engine;

export var InteractionManager = /*#__PURE__*/function () {
  function InteractionManager(engine, container) {
    _classCallCheck(this, InteractionManager);

    this.container = container;

    _InteractionManager_engine.set(this, void 0);

    __classPrivateFieldSet(this, _InteractionManager_engine, engine, "f");

    this.externalInteractors = [];
    this.particleInteractors = [];
    this.init();
  }

  _createClass(InteractionManager, [{
    key: "init",
    value: function init() {
      var interactors = __classPrivateFieldGet(this, _InteractionManager_engine, "f").plugins.getInteractors(this.container, true);

      this.externalInteractors = [];
      this.particleInteractors = [];

      var _iterator = _createForOfIteratorHelper(interactors),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var interactor = _step.value;

          switch (interactor.type) {
            case 0:
              this.externalInteractors.push(interactor);
              break;

            case 1:
              this.particleInteractors.push(interactor);
              break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "externalInteract",
    value: function () {
      var _externalInteract = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(delta) {
        var _iterator2, _step2, interactor;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iterator2 = _createForOfIteratorHelper(this.externalInteractors);
                _context.prev = 1;

                _iterator2.s();

              case 3:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 10;
                  break;
                }

                interactor = _step2.value;

                if (!interactor.isEnabled()) {
                  _context.next = 8;
                  break;
                }

                _context.next = 8;
                return interactor.interact(delta);

              case 8:
                _context.next = 3;
                break;

              case 10:
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](1);

                _iterator2.e(_context.t0);

              case 15:
                _context.prev = 15;

                _iterator2.f();

                return _context.finish(15);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 12, 15, 18]]);
      }));

      function externalInteract(_x) {
        return _externalInteract.apply(this, arguments);
      }

      return externalInteract;
    }()
  }, {
    key: "particlesInteract",
    value: function () {
      var _particlesInteract = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(particle, delta) {
        var _iterator3, _step3, interactor, _iterator4, _step4, _interactor;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _iterator3 = _createForOfIteratorHelper(this.externalInteractors);

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    interactor = _step3.value;
                    interactor.reset(particle);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                _iterator4 = _createForOfIteratorHelper(this.particleInteractors);
                _context2.prev = 3;

                _iterator4.s();

              case 5:
                if ((_step4 = _iterator4.n()).done) {
                  _context2.next = 12;
                  break;
                }

                _interactor = _step4.value;

                if (!_interactor.isEnabled(particle)) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 10;
                return _interactor.interact(particle, delta);

              case 10:
                _context2.next = 5;
                break;

              case 12:
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](3);

                _iterator4.e(_context2.t0);

              case 17:
                _context2.prev = 17;

                _iterator4.f();

                return _context2.finish(17);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 14, 17, 20]]);
      }));

      function particlesInteract(_x2, _x3) {
        return _particlesInteract.apply(this, arguments);
      }

      return particlesInteract;
    }()
  }, {
    key: "handleClickMode",
    value: function handleClickMode(mode) {
      var _iterator5 = _createForOfIteratorHelper(this.externalInteractors),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var interactor = _step5.value;

          if (interactor.handleClickMode) {
            interactor.handleClickMode(mode);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }]);

  return InteractionManager;
}();
_InteractionManager_engine = new WeakMap();